<app-modal-header [automaticClose]="false" (closeEvent)="onClose()">
  <div class="flex">
    <svg-icon
      class="flex w-24"
      [src]="'assets/images/logos/' + ((isExternal$ | async) ? 'logo-weekly.svg' : 'logo-eclass.svg')"
    ></svg-icon>
    <hr app-modal-divider />
    <div class="flex flex-col justify-center text-base-gray-500">
      <p class="text-2xl leading-none">
        {{ !!info?.title ? info?.title : ('geral.informe-titulo' | translate) }}
      </p>
    </div>
  </div>
</app-modal-header>

<div app-modal-content class="h-full w-full overflow-hidden p-0! md:h-[65vh] md:w-[90vw] lg:h-[85vh] xl:h-[75vh]">
  <app-sidenav-group>
    <ng-template app-sidenav-start opened="true">
      <div class="rounded-bl-lg px-5">
        <app-sidenav-answer [data]="info"></app-sidenav-answer>
      </div>
    </ng-template>

    <ng-template app-sidenav-outer>
      <div class="grid h-[500px] w-full overflow-auto md:h-full lg:grid-cols-3">
        <app-card class="flex flex-col rounded-none rounded-l-lg! lg:col-span-3">
          <div app-card-content class="flex flex-col gap-6">
            <!-- warnings -->
            @if (!!situationalPhrase) {
              @if (!!controls?.allow) {
                @if (!controls?.beforeDeadline) {
                  <div class="flex flex-row rounded-md border-2 border-base-mandy-700 bg-base-mandy-400 p-2">
                    <svg-icon class="ml-4 w-7 text-base-mandy-700" src="assets/icons/icon-megaphone.svg"></svg-icon>
                    <p class="ml-4 text-lg">{{ situationalPhrase }}</p>
                  </div>
                } @else {
                  @if (controls?.deadline <= 5) {
                    <div class="flex flex-row rounded-md border-2 border-base-warm-300 bg-base-warm-100 p-2">
                      <svg-icon class="ml-4 w-7 text-base-warm-400" src="assets/icons/icon-megaphone.svg"></svg-icon>
                      <p class="ml-4 text-lg">{{ situationalPhrase }}</p>
                    </div>
                  }
                }
              } @else {
                @if (controls?.revised && controls?.concluded) {
                  <div class="flex flex-row rounded-md border-2 border-base-genoa-700 bg-base-genoa-400 p-2">
                    <svg-icon class="ml-4 w-7 text-base-genoa-700" src="assets/icons/icon-megaphone.svg"></svg-icon>
                    <p class="ml-4 text-lg">{{ situationalPhrase }}</p>
                  </div>
                } @else {
                  <div class="flex flex-row rounded-md border-2 border-base-mandy-700 bg-base-mandy-400 p-2">
                    <svg-icon class="ml-4 w-7 text-base-mandy-700" src="assets/icons/icon-megaphone.svg"></svg-icon>
                    <p class="ml-4 text-lg">{{ situationalPhrase }}</p>
                  </div>
                }
              }
            }

            <!-- text editor-->
            <form [formGroup]="form">
              <div class="mb-5 flex">
                <div class="w-full items-center justify-center rounded-lg bg-white p-2 shadow-md md:flex">
                  <div class="grid w-full rounded-b-lg bg-white px-4 py-2">
                    <span class="mb-5 text-md font-semibold" translate>eclass.resposta</span>
                    <app-text-editor
                      formControlName="answer"
                      [readOnly]="this.status !== 3 && this.status !== 1"
                      [value]="controls?.studentAnswer"
                      [url]="ckeditorUploadImageUrl"
                    ></app-text-editor>
                  </div>
                </div>
              </div>
              <div class="grid w-full gap-5">
                <app-card class="h-[400px] w-full rounded-none rouØded-br-lg! bg-gray-50! pb-5 shadow-inner! md:h-full">
                  <div app-card-content>
                    <div class="w-full pt-4">
                      <h1 class="mb-4 text-lg text-base-gray-500" translate>
                        <div [innerHTML]="getTranslate('arquivos-anexos')"></div>
                      </h1>
                      <app-attachment-dropzone
                        [maxSizeMB]="config.maxFilesize"
                        [accept]="config.acceptedFiles"
                        [multiple]="config.maxFiles > 1"
                        [maxFiles]="config.maxFiles"
                        [folder]="config.params.folder"
                        [initialAttachments]="existingAttachments"
                        [disabled]="this.status !== 3 && this.status !== 1"
                        (uploadComplete)="onUploaded($event)"
                        (filesChanged)="onFilesChanged($event)"
                        (removeExisting)="onFileRemoved($event)"
                      ></app-attachment-dropzone>
                    </div>
                  </div>
                </app-card>
              </div>
            </form>
          </div>
          @if (this.status === 3 || this.status === 1) {
            <div class="flex w-full justify-end p-5">
              <button
                app-button
                (click)="onSend()"
                [disabled]="disable"
                class="mt-6 justify-end bg-theme-500 px-20 uppercase text-theme-contrast"
                translate
              >
                eclass.enviar
              </button>
            </div>
          }
        </app-card>
      </div>
    </ng-template>
    <!-- grade -->
    <ng-template app-sidenav-end>
      <div class="flex h-full w-full flex-col">
        <app-card class="w-full rounded-none bg-gray-50! shadow-inner!">
          <div app-card-content>
            <h1 class="text-lg text-base-gray-500" translate>
              <span class="text-lg font-semibold" translate>eclass.nota</span>
            </h1>
            <div class="flex flex-col items-center p-4">
              @if (!!controls?.revised && controls?.score) {
                <p class="text-3xl font-bold">{{ controls?.score }}</p>
              } @else {
                <svg-icon src="assets/icons/icon-check.svg" class="w-7 text-gray-300"></svg-icon>
                <p class="text-base" translate>eclass.sem-nota</p>
              }
            </div>
          </div>
        </app-card>
        @if (!!hasFeedback) {
          <app-card class="mt-5 h-full w-full rounded-none bg-gray-50! shadow-inner!">
            <div app-card-content>
              <h1 class="text-lg lowercase text-base-gray-500" translate>
                <span class="text-lg font-semibold capitalize" translate>eclass.feedback</span> eclass.professor-a
              </h1>
              @for (file of feedbacks; track file) {
                @if (file.extension !== 'html') {
                  <div
                    app-button
                    class="mb-2 mt-2 flex w-full items-center justify-between! rounded-lg bg-white p-3 shadow-md"
                  >
                    <div class="flex justify-start">
                      <svg-icon class="mr-5 mt-1 w-8 min-w-[25px]" [src]="icon(file.extension)"></svg-icon>
                      <div class="ml-1 grid">
                        <div class="relative flex truncate hover:text-clip">
                          <span class="whitespace-nowrap text-md font-semibold hover:animate-marquee">
                            {{ file.title }}
                          </span>
                        </div>
                        <span class="text-base text-base-gray-400">
                          {{ file.updated_at | date: 'dd/MM/yyyy HH:mm' }} - {{ file.user?.name }}
                        </span>
                      </div>
                    </div>
                    <div class="flex justify-end">
                      @if (!!canDownload(file.extension)) {
                        <svg-icon
                          class="w-9 min-w-[16px] cursor-pointer pr-2 text-modules-eclass-500"
                          (click)="onDownload(file)"
                          src="assets/icons/icon-download.svg"
                        ></svg-icon>
                      }
                      <svg-icon
                        class="w-8 min-w-[16px] cursor-pointer pt-1 text-modules-eclass-500"
                        (click)="onOpenFeedbackAttachment(file)"
                        src="assets/icons/icon-eyes.svg"
                      ></svg-icon>
                    </div>
                  </div>
                } @else {
                  <div
                    class="mb-2 mt-2 flex min-h-[50px] w-full items-center rounded-lg border border-dashed bg-white shadow-md transition-all duration-500"
                  >
                    <p class="p-3 text-left text-sm font-semibold text-base-gray-400">
                      {{ file.updated_at | date: 'dd/MM HH:mm' }} {{ file.user?.name }}:
                      <span class="text-base">
                        {{ file.description }}
                      </span>
                    </p>
                  </div>
                }
              }
            </div>
          </app-card>
        }
      </div>
    </ng-template>
  </app-sidenav-group>
</div>
